import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "./initialState";
import { registerStockPublicationExtraReducers } from "./extraReducers";
import { stockPublicationReducers } from "./reducers";

export const stockPublicationSlice = createSlice({
  name: "stockPublication",
  initialState,
  reducers: stockPublicationReducers,
  extraReducers: registerStockPublicationExtraReducers,
});

export const {
  setHiddenBrands,
  setHiddenModels,
  setHiddenSizes,
  setHiddenDrillings,
  setMaxVisibleQuantity,
  setHideLastFullSet,
  addMarkupRule,
  removeMarkupRule,
} = stockPublicationSlice.actions;

export default stockPublicationSlice;
